import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {ParameterService} from "../../_services/parameter.service";
import {NewCertificationService} from "./services/new-certification.service";
import {AssociationService} from "../associactions/services/association.service";
import {CertificationRefreshService} from "./services/certification-refresh.service";

@Component({
    selector: 'app-new-certification-detail',
    templateUrl: './new-certification-detail.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationDetailComponent extends BaseComponentDirective implements OnInit {


    attendanceTypes: any = {};
    associations: any[] = [];
    activities: any[] = [];
    restricted: number = 0;

    providerId: any = null;
    certification: any = null;

    activeTab = 'overview';

    constructor(
        injector: Injector,
        private parameterService: ParameterService,
        private certificationService: NewCertificationService,
        private associationService: AssociationService,
        private refreshSvc: CertificationRefreshService
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        await this.rebuildData();
        switch (this.activatedRoute.snapshot.queryParams.tab) {
            case 'overview': this.activeTab = 'overview'; break;
            case 'detail': this.activeTab = 'detail'; break;
            case 'domains': this.activeTab = 'domains'; break;
            case 'objectives': this.activeTab = 'objectives'; break;
            default: this.activeTab = 'overview'; break;
        }
        this.refreshSvc.currentMessage.subscribe(async r => {
            if(r) {
                await this.rebuildData();
            }
        })

    }

    async rebuildData() {
        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.associations = await this.associationService.getAllNoPaging();
        this.certification = await this.certificationService.getById(this.activatedRoute.snapshot.params.certificationId);

        this.activities = await this.certificationService.getActivityByCertificationId(this.certification?.id);
        this.certification['associationName'] = this.associations.find(r => r.id == this.certification?.association.id)?.providerName;

        let r = await this.associationService.getActivitiesByProviderIdNoPaging(this.certification?.association.id);

        this.restricted = 0;
        for(let i = 0; i < r.length; i++) {
            this.restricted += r[i].conditions.length;
        }

    }

    goEdit(certificationId: number) {
        this.router.navigate([`/office/new-certification/detail/${certificationId}/edit`]).then();
    }

    mergeAttendanceTypes(data: any[]) {
        if(!data || data.length == 0) return '';
        return data.map(item => item.attendanceTypeLabel).join(", ");
    }
}
